import styled from 'styled-components'
import {
  ContainerTitle,
  DivTitle,
} from '../../../components/TitlePage/TitlePage'
import Close from '../../../assets/icons/close'
import { ButtonClosed, Title } from './style'
import {
  BtnSave,
  FormLogin,
  InputLogin,
  LabelLogin,
  SelectVinculo,
} from '../../UsersAdm/newUserAdm/style'
import { formataCPF } from '../../../utils/cpfMask'
import { CpfsVendedores } from '../../../components/CpfsVendedores/CpfsVendedores'
import { papelMultiVendedor } from '../useUsers'
import { colors } from '../../../theme'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2001;
`

const Card = styled.div`
  width: 440px;
  max-height: 88vh;
  overflow-y: auto;
  background-color: ${colors.surface};
  border-radius: 10px;
  padding: 24px 30px 30px 30px;
`

const Campos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  margin-top: 28px;

  input,
  select {
    width: 100%;
    box-sizing: border-box;
  }
  select {
    height: 42px;
    border-radius: 12px;
    border: 1px solid ${colors.grey300};
    padding: 0 12px;
    font-size: 14px;
  }
`

const ErroMsg = styled.span`
  display: block;
  color: ${colors.errorText};
  font-size: 13px;
  margin-top: 14px;
  text-align: center;
`

const Info = styled.p`
  color: ${colors.grey900};
  background-color: ${colors.grey100};
  border-radius: 10px;
  font-size: 13px;
  padding: 12px 14px;
  margin: 0;
  text-align: left;
`

type NovoUsuarioOrgProps = {
  modal: () => void
  nome: string
  setNome: (v: string) => void
  email: string
  onEmailChange: (v: string) => void
  onEmailBlur: () => void
  emailJaExiste: boolean
  verificandoEmail: boolean
  senha: string
  setSenha: (v: string) => void
  confirmarSenha: string
  setConfirmarSenha: (v: string) => void
  papel: PapelOrganizacaoType
  setPapel: (v: PapelOrganizacaoType) => void
  cpf: string
  setCpf: (v: string) => void
  cpfs: string[]
  setCpfs: (v: string[]) => void
  erro: string
  salvando: boolean
  onSalvar: (fechaModal: () => void) => void
}

export function NovoUsuarioOrg({
  modal,
  nome,
  setNome,
  email,
  onEmailChange,
  onEmailBlur,
  emailJaExiste,
  verificandoEmail,
  senha,
  setSenha,
  confirmarSenha,
  setConfirmarSenha,
  papel,
  setPapel,
  cpf,
  setCpf,
  cpfs,
  setCpfs,
  erro,
  salvando,
  onSalvar,
}: NovoUsuarioOrgProps) {
  return (
    <Overlay>
      <Card>
        <DivTitle color="black" size={22}>
          <Title>
            <ContainerTitle>Novo usuário</ContainerTitle>
            <ButtonClosed type="button" onClick={modal}>
              <Close />
            </ButtonClosed>
          </Title>
        </DivTitle>

        <Campos>
          <FormLogin>
            <LabelLogin htmlFor="novoNome">Nome completo</LabelLogin>
            <InputLogin
              id="novoNome"
              type="text"
              value={nome}
              onChange={event => setNome(event.target.value)}
            />
          </FormLogin>

          <FormLogin>
            <LabelLogin htmlFor="novoEmail">E-mail</LabelLogin>
            <InputLogin
              id="novoEmail"
              type="email"
              value={email}
              onChange={event => onEmailChange(event.target.value)}
              onBlur={onEmailBlur}
            />
            {verificandoEmail ? <span>Verificando e-mail...</span> : ''}
          </FormLogin>

          {emailJaExiste ? (
            <Info>
              E-mail já cadastrado no sistema. O usuário existente será
              vinculado a esta organização com o nível de acesso selecionado.
            </Info>
          ) : (
            ''
          )}

          {!emailJaExiste && (
            <>
              <FormLogin>
                <LabelLogin htmlFor="novoSenha">Senha</LabelLogin>
                <InputLogin
                  id="novoSenha"
                  type="password"
                  value={senha}
                  onChange={event => setSenha(event.target.value)}
                />
              </FormLogin>

              <FormLogin>
                <LabelLogin htmlFor="novoConfirmar">Confirmar senha</LabelLogin>
                <InputLogin
                  id="novoConfirmar"
                  type="password"
                  value={confirmarSenha}
                  onChange={event => setConfirmarSenha(event.target.value)}
                />
              </FormLogin>
            </>
          )}

          <FormLogin>
            <LabelLogin htmlFor="novoPapel">Nível de acesso</LabelLogin>
            <SelectVinculo
              id="novoPapel"
              value={papel}
              onChange={event =>
                setPapel(event.target.value as PapelOrganizacaoType)
              }
            >
              <option value="ADMINISTRADOR">Administrador</option>
              <option value="COORDENADOR">Coordenador</option>
              <option value="ASSISTENTE">Assistente</option>
              <option value="VENDEDOR">Vendedor</option>
            </SelectVinculo>
          </FormLogin>

          {papel === 'VENDEDOR' && (
            <FormLogin>
              <LabelLogin htmlFor="novoCpf">CPF</LabelLogin>
              <InputLogin
                id="novoCpf"
                type="text"
                value={formataCPF(cpf)}
                onChange={event => setCpf(event.target.value)}
              />
            </FormLogin>
          )}

          {/* PD-0004: coordenador e assistente acompanham varios vendedores. */}
          {papelMultiVendedor(papel) && (
            <CpfsVendedores cpfs={cpfs} onChange={setCpfs} idPrefix="novo" />
          )}
        </Campos>

        {erro ? <ErroMsg>{erro}</ErroMsg> : ''}

        <BtnSave
          type="button"
          disabled={salvando}
          onClick={() => onSalvar(modal)}
        >
          {salvando ? 'Salvando...' : 'Salvar'}
        </BtnSave>
      </Card>
    </Overlay>
  )
}
